/**
 * Address settings API client (BFF: `/api/v1/store/settings/address`).
 *
 * Address formats/validation plus the geocoding/suggestion provider connection test
 * (→ web-address-service). The provider secret is write-only on update.
 */
import { apiClient } from '@/shared/api';
import type {
  AddressSettings,
  TestConnectionResult,
  UpdateAddressSettingsRequest,
} from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/address';

export const getAddressSettings = async (): Promise<AddressSettings> =>
  (await apiClient.get<AddressSettings>(BASE)).data;

export const updateAddressSettings = async (
  body: UpdateAddressSettingsRequest,
): Promise<AddressSettings> => (await apiClient.put<AddressSettings>(BASE, body)).data;

export const testAddressProviderConnection = async (): Promise<TestConnectionResult> =>
  (await apiClient.post<TestConnectionResult>(`${BASE}/provider/test-connection`)).data;
